import { auth } from '@/services/api'
import store from "@/store"

class AuthService {
  // login
  static authenticate (credentials) {
    return auth.post('/login', credentials)
      .then((response) => response.data)
  }

  // login com certificado
  static authenticateChallenge (challenge, signedChallenge, certificate) {
    return auth
      .post('/login-certificado', {
        challenge,
        signedChallenge,
        certificate
      }).then((response) => response.data)
  }

  // verifica se esta logado
  static checkIsLoggedIn () {
    return auth.get('/me').then(res => {
      if (res.data && res.data.flag_oficial && !res.data.escrevente) {
        res.data.escrevente = 1
      }

      return res
    })
  }

  // pega dados do usuario
  static me (token) {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }

    return auth.get('/me', config).then(res => {
      if (res.data && res.data.flag_oficial && !res.data.flag_escrevente) {
        res.data.flag_escrevente = 1
      }

      return res
    })
  }

  // login IDRC
  static loginIDRC (token) {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }

    return auth.get('/loginIDRC', config).then(res => {
      if (res.data && res.data.flag_oficial && !res.data.flag_escrevente) {
        res.data.flag_escrevente = 1
      }

      return res
    })
  }

  static loginCheck (userId) {
    return auth.get(`/loginCheck/${ userId }`).then(res => {
      if (res.data && res.data.flag_oficial && !res.data.flag_escrevente) {
        res.data.flag_escrevente = 1
      }

      return res
    })
  }
  // editar senha
  static editarSenha (senhaAtual, novaSenha) {
    return auth.put('/alterar-senha', { senhaAtual, novaSenha }).then((response) => response.data)
  }
}

export default AuthService
